import Cookie from 'js-cookie';

export async function getAdtractionId() {
  const sys_adtraction_id = Cookie.get('at_gd');

  if (!sys_adtraction_id) return {};

  return {
    sys_adtraction_id,
  };
}
